import {
  Cohort,
  FunnelTheme,
  PageVersions,
  SubscriptionProduct,
} from 'root-constants'
import { TFunnelTheme, TPageVersion } from 'root-types'

export type TPurchaseLongVersionMap = Partial<Record<Cohort, TPageVersion>> & {
  default: TPageVersion
}

export const FUNNEL_THEME_TITLE_COHORTS: readonly Cohort[] = [
  Cohort.FINAL_MONTHLY_AYAH,
  Cohort.FINAL_MONTHLY_AYAH_AM,
]

export const TITLE_VERSION_BY_FUNNEL_THEME = {
  [FunnelTheme.ADDICT]: PageVersions.V5,
  [FunnelTheme.GENERAL]: PageVersions.V4,
  [FunnelTheme.FINANCE]: PageVersions.V9,
} as const satisfies Record<TFunnelTheme, TPageVersion>

export const getFunnelThemeTitleContext = (
  cohort: Cohort,
  funnelTheme: string | null,
  fallbackContext: TPageVersion,
): TPageVersion => {
  if (!FUNNEL_THEME_TITLE_COHORTS.includes(cohort)) {
    return fallbackContext
  }

  return (
    TITLE_VERSION_BY_FUNNEL_THEME[funnelTheme as TFunnelTheme] ??
    fallbackContext
  )
}

export const DEFAULT_DISCOUNT = 50

export const TEN_MINUTES = {
  IN_SECONDS: 600,
  AS_STRING: '10:00',
}

export const HIGHLIGHTS_ORDER = [1, 2, 3, 4, 5]

export const LONG_PAYWALL_TRACKED_BREAKPOINTS: number[] = [
  16, 33, 50, 66, 83, 100,
]

export const VISIBLE_FACT_BY_CONTEXT: TPageVersion[] = [
  PageVersions.V3,
  PageVersions.V4,
  PageVersions.V5,
]

export const DISCLAIMER = {
  [SubscriptionProduct.SEVEN_DAY]: 'purchase2.disclaimerWeekly',
  [SubscriptionProduct.ONE_MONTH]: 'purchase2.disclaimerMonthly',
  [SubscriptionProduct.THREE_MONTHS]: 'purchase2.disclaimerQuarterly',
}

export const PURCHASE_LONG_BY_VERSION_MAP: TPurchaseLongVersionMap = {
  [Cohort.FLOW_1_INTRO_LONG_2248]: PageVersions.V2,
  [Cohort.FINAL_MONTHLY]: PageVersions.V2,
  [Cohort.FLOW_1_INTRO_LONG_2466]: PageVersions.V3,
  [Cohort.G_6007]: PageVersions.V4,
  [Cohort.FLOW_1_INTRO_LONG_2251]: PageVersions.V5,
  [Cohort.FLOW_1_INTRO_LONG_2252]: PageVersions.V5,
  [Cohort.FLOW_1_INTRO_LONG_2253]: PageVersions.V5,
  [Cohort.FLOW_1_INTRO_LONG_2271]: PageVersions.V5,
  [Cohort.FLOW_1_INTRO_LONG_2271_C]: PageVersions.V5,
  default: PageVersions.V5,
}

export const PURCHASE_LONG_V2_BY_VERSION_MAP: TPurchaseLongVersionMap = {
  default: PageVersions.V5,
}
